import React from "react";
import { Shield } from "lucide-react";
import cls from "./styles.module.scss";

export function ShieldLogo() {
  return (
    <div className={cls.wrapper}>
      <div className={cls.pulse}>
        <Shield className={cls.icon} strokeWidth={1.5} />
      </div>

      <div className={cls.glow} />
    </div>
  );
}
